module.exports = __webpack_public_path__ + "img/17_retarding_proofing_(white).9e9e4512.svg";